import hsaLogo from './hsa.png';
import ahsLogo from './ahs.png';
import twoTenLogo from './twoten.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Timeframe } from './components/Timeframe.js';
import { Headline } from './components/Headline.js';
import UserForm from './components/UserForm.js';
import SweepstakesUserForm from './components/SweepstakesUserForm.js';
import { ThankYou } from './components/ThankYou.js';
import { Footer } from './components/Footer.js';
import { Modal } from './components/Modal.js';
import ServiceRequest from './components/ServiceRequest.js';
import React, { Component } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import LoadingOverlay from 'react-loading-overlay-ts';
import { format } from 'react-string-format';

const prodApiUrl = "https://services.messagegears.io/form/form-submit?fm={0}";
const localApiUrl = "http://3.228.122.224:8081/form/form-submit?fm={0}";
const sweepstakesSubmitUrl = "https://r3zh4r7kxjdat7la4q4t7bvxra0nirxl.lambda-url.us-east-1.on.aws/";
const timeframes = {
  0: "Within 30 days",
  1: "Longer than 30 days",
  2: "Not sure"
}
const serviceRequestOptions = {
  0: "Yes",
  1: "No", 
  2: "I don't have HVAC coverage."
}
const query = new URLSearchParams(window.location.search);
const hsaLinks = {
  specialOffers: "https://myaccount.myhomewarranty.com/hb/special-offers/108080?contractId={0}&zipCode={1}",
  hvacInspection: "https://myaccount.myhomewarranty.com/hb/diy/7073?contractId={0}&zipCode={1}",
  howLong: "https://myaccount.myhomewarranty.com/hb/diy/7074?contractId={0}&zipCode={1}",
  myAccount: "https://myaccount.myhomewarranty.com/login",
  policy: "https://www.onlinehsa.com/privacy-policy/",
  terms: null
}
const ahsLinks = {
  specialOffers: "https://myaccount.ahs.com/hb/special-offers/107979?contractId={0}&zipCode={1}",
  hvacInspection: "https://myaccount.ahs.com/hb/diy/7073?contractId={0}&zipCode={1}",
  howLong: "https://myaccount.ahs.com/hb/diy/7074?contractId={0}&zipCode=",
  myAccount: "https://www.ahs.com/my-account/pages/register.jsp/customer=true",
  policy: "https://www.ahs.com/privacy-policy",
  terms: "https://www.ahs.com/terms-of-use/"
}
const twoTenLinks = {
  specialOffers: "https://myaccount.2-10.com/hb/special-offers/777979?contractID={0}&zipCode={1}",
  hvacInspection: "https://myaccount.ahs.com/hb/diy/7073?contractId={0}&zipCode={1}",
  howLong: "https://myaccount.ahs.com/hb/diy/7074?contractId={0}&zipCode=",
  homeownerPortal: "https://myaccount.2-10.com/hb",
  policy: "https://www.2-10.com/privacy-policy/",
  terms: "https://www.2-10.com/terms-and-conditions/"
}
const sweepstakesTeams = {
  rangers: {
    formId: "BASEBALL_SWEEPS_RANGERS",
    rulesUrl: "https://i.mg.frontdoorhome.com/Baseball_Sweepstakes/0726_Rangers_rules_sweepstakes.pdf"
  },
  diamondbacks: {
    formId: "BASEBALL_SWEEPS_DIAMONDBACKS",
    rulesUrl: "https://i.mg.frontdoorhome.com/Baseball_Sweepstakes/0726_diamondbacks_rules_sweepstakes.pdf"
  }
}

class App extends Component {
  
  constructor() {
    super();
    this.state = {
      loading: false,
      email: null,
      showForm: false,
      showMenu: true,
      showThankYou: false,
      timeframe: 0,
      showHeadline: true,
      headline: "Welcome! Thank you for your interest in the New HVAC Program",
      subhead: "With this program you can save thousands* off national retail prices and improve the efficiency of your home. Use the form below to schedule your free in-home quote with one of our HVAC professionals.",
      message: null,
      name: null,
      phone: null,
      address: null,
      city: null,
      state: null,
      zip: "",
      source: null,
      campaign: 0,
      links: [],
      working: null,                     
      brand: "HSA℠",
      logo: hsaLogo,                              
      showModal: false,
      showServiceRequest: false,
      openServiceRequest: null,
      userFormMessage: "Please complete the form below so we, our affiliates and our Pros can contact you and provide you with a FREE in-home quote.  For more information, see our  <a href=\"https://www.ahs.com/privacy-policy\">Privacy Policy</a> and <a href=\"https://www.ahs.com/terms-of-use\">Terms of Use.",
      cta: null,
      bottomMessage: null,
      linkObj: hsaLinks,
      addStyle: false, 
      addTwoTenStyle: false,
      footerBrand: "HSA",
      footerDisclaimer: "Home Security of America",
      apiUrl: prodApiUrl,
      agent: false,
      agentId: null, 
      contractId: 0,
      zipCode: "",
      sendTransactional: false,
      customProperties: {
        campaignName: "HSA UPGRADE FROM SUBMISSION"
      },
      application: null,
      showSweepstakesForm: false,
      marketingPartner: null,
      adname: null,
      confirmation: null,
      productType: null,
      campaignName: null,
      marketingConsent: false,
      termsAgree: false,
      rulesUrl: null,
    }
  }

  componentDidMount() {
    let formId = 'HVAC';
    const sweepstakesTeamConfig = sweepstakesTeams[this.props.sweepstakesTeam] || {};
    if (this.props.sweepstakes) {
      formId = sweepstakesTeamConfig.formId || 'HVAC_SWEEPS';
    }
    const hostName = window.location.hostname;
    document.title = "HSA - HVAC";
    if (hostName === "localhost" || hostName === "127.0.0.1") {
      this.setState({ "apiUrl": format(localApiUrl, formId) });
    } else {
      this.setState({ "apiUrl": format(prodApiUrl, formId) });
    }
    const confirmation = query.get("confirmation");
    if (confirmation) {
      this.setState({ "confirmation": confirmation });
    }
    this.setState({ "email": query.get("email") });
    const productType = query.get("productType");
    if (productType) {
      this.setState({ "productType": productType });
    }
    const cId = query.get("cid");
    if (cId) {
      this.setState({ "campaign": query.get("cid") });
    }
    const application = query.get("application");
    if (application) {
      this.setState({ "application": query.get("application") });
    }
    const source = query.get("source");
    if (source) {
      this.setState({ "source": source });
    } else {
      this.setState({ "source": "hsa" });
    }
    if (source && source.includes("ahs")) {
      this.setState ({ "sendTransactional": true });
      this.setState({ "brand": "American Home Shield®" });
      this.setState({ "footerBrand": "AHS"});
      document.title = "AHS - HVAC";
      this.setState({ "footerDisclaimer": "American Home Shield" });
      this.setState({ "logo": ahsLogo });
      this.setState({ "linkObj": ahsLinks });
      this.setState({ "addStyle": true });
      this.setState({ "links": [{
        link: this.state.linkObj.howLong,
        button: "Go Back to MyAccount",
        text: ""
      }]});
      this.setState({ "customProperties": {
        campaignName: "AHS UPGRADE FROM SUBMISSION"
      }})
    }
    if (source && (source.includes("2-10") || source.toLowerCase().includes("hbw210"))) {
      const favicon = document.getElementById("favicon");
      favicon.setAttribute("href", "favicon-210.ico");
      this.setState({"source": "2-10" });
      this.setState({ "logo": twoTenLogo });
      this.setState({ "brand": "2-10" })
      this.setState({ "footerDisclaimer": "Home Buyers Warranty" });
      document.title = "2-10 - HVAC";
      this.setState({ "linkObj": twoTenLinks });
      this.setState({ "addTwoTenStyle": true });
      this.setState({ "userFormMessage": "Please complete the form below so we, our affiliates and our Pros can contact you and provide you with a FREE in-home quote.  For more information, see our  <a href=\"https://www.2-10.com/privacy-policy\">Privacy Policy</a> and <a href=\"https://www.2-10.com/terms-and-conditions\">Terms of Use." });
      this.setState({ "confirmation": "hbw210" });
    }
    if (this.props.sweepstakes) {
      const favicon = document.getElementById("favicon");
      favicon.setAttribute("href", "/favicon-ahs.png");
      const fb = document.getElementById('fbscript');
      if (!fb) {
        const script = document.createElement('script');
        script.src = '/fb.js';
        script.async = true;
        script.id = 'fbscript';
        document.body.appendChild(script);
      }
      const marketingPartner = query.get("MarketingPartner");
      if (marketingPartner) {
        this.setState({ "marketingPartner": marketingPartner });
      }
      const adName = query.get("adname");
      if (adName) {
        this.setState({ "adname": adName });
      }
      const campaignName = query.get("campaign");
      if (campaignName) {
        this.setState( {"campaignName": campaignName});
      }
      this.setState({ "source": "ahs" });
      this.setState({ "showMenu": false });
      this.setState({ "sendTransactional": true });
      this.setState({ 'headline': "Enter to Win a $100 Gift Card" });
      this.setState({ 'subhead': "Complete the form below for a chance to win a $100 gift card.  No purchase or payment of any kind is necessary for entry. A purchase or payment of any kind will not increase chances of winning.  Open to US residents 18+.  See <a href=\"" + (sweepstakesTeamConfig.rulesUrl || "#") + "\" target=\"_blank\">Official Rules</a> for prize details, and entrant limitations."})
      this.setState({ "rulesUrl": sweepstakesTeamConfig.rulesUrl });
      this.setState({ "showSweepstakesForm": true });
      this.setState({ "brand": "American Home Shield®" });
      this.setState({ "footerBrand": "AHS"});
      document.title = "AHS - HVAC";
      this.setState({ "footerDisclaimer": "American Home Shield" });
      this.setState({ "logo": ahsLogo });
      this.setState({ "linkObj": ahsLinks });
      this.setState({ "addStyle": true });
      this.setState({ "links": [{
        link: this.state.linkObj.howLong,
        button: "Go Back to MyAccount",
        text: ""
      }]});
      this.setState({ "customProperties": {
        campaignName: "AHS UPGRADE FROM SUBMISSION"
      }})
    }
    const agent = query.get("agent");
    if (agent) {
      this.setState({ "agent": true });
      this.setState({ "agentId": agent });
    }
    const contractId = query.get('contractId');
    if (contractId) {
      this.setState({ "contractId": contractId });
    }
    const zipCode = query.get('zipCode');
    if (zipCode) {
      this.setState({ "zip": zipCode });
    }
    const name = query.get('name');
    if (name) {
      this.setState({ "name": name });
    }
    const phone = query.get('phone_number');
    if (phone) {
      try {
        const decodedPhone = atob(phone);
        this.setState({ "phone": decodedPhone });
      } catch (error) {
        console.error("Error decoding phone number:", error);
      }
    }
    const address = query.get('street');
    if (address) {
      try {
        const decodedAddress = atob(address);
        this.setState({ "address": decodedAddress });
      } catch (error) {
        console.error("Error decoding address:", error);
      }
    }
    const city = query.get('city');
    if (city) {
      this.setState({ "city": city });
    }

    const state = query.get('state');
    if (state) {
      this.setState({ "state": state });
    }

    const emailEncoded = query.get('enc_email');
    if (emailEncoded) {
      try {
        const decodedEmail = atob(emailEncoded);
        this.setState({ "email": decodedEmail });
      } catch (error) {
        console.error("Error decoding email:", error);
      }
    }
  }

  formPost = () => {
    this.setState({ "message": "<h1>THANK YOU!</h1>The " + this.state.brand + " New HVAC Program is powered by Frontdoor Pro®. One of their trusted, independent service contractors will contact you within 2 business days to schedule your FREE in-home HVAC upgrade quote."});
    this.post();
  }

  post = () => {
    this.setState({ "loading": true});
    this.setState({ "links": [{
      link: format(this.state.linkObj.specialOffers, this.state.contractId, this.state.zip),
      button: "What to Expect",
      text: ""
    }]});
    let campaign = this.state.campaign;
    if (this.state.sendTransactional && this.state.timeframe === "0" && this.state.working === "yes") {
      campaign = 16222244;
    } else if (this.state.source == "2-10") {
      campaign = 87300946;
    } else if ((this.state.source == null || this.state.source === 'hsa') && this.state.timeframe === "0" && (this.state.working === "yes" || (this.state.working === "no" && this.state.openServiceRequest == 2))) {
      campaign = 40721959;
    }
    const url = new URL(this.state.apiUrl);
    url.searchParams.set('email', this.state.email);
    url.searchParams.set('cId', campaign);
    url.searchParams.set('confirmation', this.state.confirmation);
    url.searchParams.set('name', this.state.name);
    url.searchParams.set('address', this.state.address);
    url.searchParams.set('phone', this.state.phone);
    url.searchParams.set('city', this.state.city);
    url.searchParams.set('state', this.state.state);
    url.searchParams.set('zip', this.state.zip);
    url.searchParams.set('source', this.state.source);
    url.searchParams.set('timeframe', timeframes[this.state.timeframe]);
    url.searchParams.set('servicerequest', serviceRequestOptions[this.state.openServiceRequest]);
    url.searchParams.set('working', this.state.working);
    url.searchParams.set('contractId', this.state.contractId);
    url.searchParams.set('agent', this.state.agentId);
    url.searchParams.set('RecipientId', this.state.contractId);
    url.searchParams.set('customProperties', encodeURIComponent(JSON.stringify(this.state.customProperties)));
    url.searchParams.set('application', this.state.application);
    url.searchParams.set('productType', this.state.productType);
    if (this.props.sweepstakes) {
      url.searchParams.set('marketingPartner', this.state.marketingPartner);
      url.searchParams.set('adname', this.state.adname);
      url.searchParams.set('timeframe', null);
      url.searchParams.set('servicerequest', null);
      url.searchParams.set('campaign', this.state.campaignName);
      url.searchParams.set('marketingConsent', this.state.marketingConsent ? 'Yes' : 'No');
      url.searchParams.set('termsAgree', this.state.termsAgree ? 'Yes' : 'No');
      axios.post(sweepstakesSubmitUrl, {
        team: this.props.sweepstakesTeam,
        name: this.state.name,
        email: this.state.email,
        phone: this.state.phone,
        address: this.state.address,
        city: this.state.city,
        state: this.state.state,
        zip: this.state.zip,
        marketingConsent: this.state.marketingConsent,
        termsAgree: this.state.termsAgree
      }).catch((error) => {
        console.error("sweepstakes submission log failed:", error);
      });

      // Optimistic UI for sweepstakes: the MessageGears form-submit endpoint can take
      // several seconds to respond. Don't make the entrant wait on it - show the
      // thank-you screen immediately and let the submission complete in the background.
      axios.post(url.toString()).catch((error) => {
        console.log(error);
      });
      this.setState({ "showForm": false });
      this.setState({ "showSweepstakesForm": false });
      this.setState({ "showHeadline": false });
      this.setState({ "links": [] });
      this.setState({ "message": "<h1>Entry submitted, thanks!</h1>For more information about American Home Shield, please visit <a href='https://www.ahs.com'>www.ahs.com</a>."})
      this.setState({ "showThankYou": true });
      this.setState({ "loading": false});
      return;
    }
    axios.post(url.toString()).then((response) => {
      /*
      if (this.props.sweepstakes) {
        const script = document.createElement('script');
        script.src = 'fb.js';
        script.async = true;
        script.id = 'fbscript';
        document.body.appendChild(script);
        const remove = document.getElementById('fbscript');
        document.body.removeChild(remove);
      } */
      this.setState({ "showForm": false });
      this.setState({ "showSweepstakesForm": false });
      this.setState({ "showHeadline": false });
      if (this.state.openServiceRequest) {
        switch (this.state.openServiceRequest) {
          case "0":
            this.setState({ "message": "Thanks for letting us know. We'll be in contact within 2 business days to follow up.<br/><br/><b>PRO TIP:</b> If your current system has a covered issue, you could potentially qualify for a home service plan credit on top of our discounted HVAC equipment pricing."});
            this.setState({ "links": [{
              link: format(this.state.linkObj.specialOffers, this.state.contractId, this.state.zip),
              button: "Learn More",
              text: "How the New HVAC program works"
            }]});
            break;
          case "1":
            switch (this.state.timeframe) {
              case "0": 
                this.setState({ "showModal": true });
                this.setState({ "message": "<h1>THANK YOU!</h1>The " + this.state.brand + " New HVAC Program is powered by Frontdoor Pro®. One of their trusted, independent service contractors will contact you within 2 business days to schedule your FREE in-home HVAC upgrade quote."});
                break;
              case "1":
                this.setState( {"bottomMessage": "<b>PLEASE NOTE:</b><br/><br/>Upgrade quotes and equipment availability are valid for 30 days, so we encourage you to submit a quote request when you’re ready to move forward.<br/><br/>In the meantime, check out these helpful resources to learn more about the New HVAC Program, as well as general HVAC maintenance tips and tricks."})
                if (this.state.source === "2-10") {
                  this.setState( {"bottomMessage": "<b>PLEASE NOTE:</b><br/><br/>Upgrade quotes and equipment availability are valid for 30 days, so we encourage you to submit a quote request when you’re ready to move forward.<br/><br/>In the meantime, learn more about the new HVAC Program."})
                  this.setState({ "message": "We encourage you to log into Homeowner Portal to file a service request with your home warranty so we can inspect your current system and review your options with you.<br/><br/><b>CREATE YOUR SERVICE REQUEST NOW."});
                  this.setState({ "links": [
                    {
                      link: format(this.state.linkObj.specialOffers, this.state.contractId, this.state.zip),
                      button: "Learn More",
                      text: "How does the New HVAC Program work?"
                    }
                  ]});
                  this.setState({ "cta": {
                    link: format(this.state.linkObj.homeownerPortal, this.state.contractId, this.state.zip),
                    button: "Log into Homeowner Portal"
                  }})
                } else {
                  this.setState({ "message": "We encourage you to log into MyAccount to file a service request with your home warranty so we can inspect your current system and review your options with you.<br/><br/><b>CREATE YOUR SERVICE REQUEST NOW."});
                  this.setState({ "links": [
                    {
                      link: format(this.state.linkObj.specialOffers, this.state.contractId, this.state.zip),
                      button: "Learn More",
                      text: "How does the New HVAC Program work?"
                    },
                    {
                      link: format(this.state.linkObj.hvacInspection, this.state.contractId, this.state.zip),
                      button: "Read More",
                      text: "How do you conduct a DIY HVAC inspection?"
                    },
                    {
                      link: format(this.state.linkObj.howLong, this.state.contractId, this.state.zip),
                      button: "Read More",
                      text: "How long do HVAC systems last?"
                    }
                  ]});
                  this.setState({ "cta": {
                    link: format(this.state.linkObj.myAccount, this.state.contractId, this.state.zip),
                    button: "Log into MyAccount"
                  }})
                }
                break;
              case "2": 
                this.setState({ "message": "We encourage you to log into MyAccount to file a service request with your home warranty so we can inspect your current system and review your options with you.<br/><br/><b>CREATE YOUR SERVICE REQUEST NOW."});
                if (this.state.source === "2-10") {
                  this.setState({ "cta": {
                    link: format(this.state.linkObj.specialOffers, this.state.contractId, this.state.zip),
                    button: "Log into Homeowner Portal"
                  }})
                  this.setState({ "links": [
                    {
                      link: format(this.state.linkObj.specialOffers, this.state.contractId, this.state.zip),
                      button: "Learn More",
                      text: "How does the New HVAC Program work?"
                    }
                  ]});
                }
                else {
                  this.setState( {"bottomMessage": "<b>PLEASE NOTE:</b><br/><br/>Upgrade quotes and equipment availability are valid for 30 days, so we encourage you to submit a quote request when you’re ready to move forward.<br/><br/>In the meantime, check out these helpful resources to learn more about the New HVAC Program, as well as general HVAC maintenance tips and tricks."});
                  this.setState({ "cta": {
                    link: format(this.state.linkObj.homeownerPortal, this.state.contractId, this.state.zip),
                    button: "Log into MyAccount"
                  }})
                  this.setState({ "links": [
                    {
                      link: format(this.state.linkObj.specialOffers, this.state.contractId, this.state.zip),
                      button: "Learn More",
                      text: "How does the New HVAC Program work?"
                    },
                    {
                      link: format(this.state.linkObj.hvacInspection, this.state.contractId, this.state.zip),
                      button: "Read More",
                      text: "How do you conduct a DIY HVAC inspection?"
                    },
                    {
                      link: format(this.state.linkObj.howLong, this.state.contractId, this.state.zip),
                      button: "Read More",
                      text: "How long do HVAC systems last?"
                    }
                  ]});
                }
                break;
              default:
                this.setState({ "message": "<h1>THANK YOU!</h1>The " + this.state.brand + " New HVAC Program is powered by Frontdoor Pro®. One of their trusted, independent service contractors will contact you within 2 business days to schedule your FREE in-home HVAC upgrade quote."});
                this.setState({ "links": [
                  {
                    link: format(this.state.linkObj.specialOffers, this.state.contractId, this.state.zip),
                    button: "Learn More",
                    text: "How does the New HVAC Program work?"
                  },
                  {
                    link: format(this.state.linkObj.hvacInspection, this.state.contractId, this.state.zip),
                    button: "Read More",
                    text: "How do you conduct a DIY HVAC inspection?"
                  },
                  {
                    link: format(this.state.linkObj.howLong, this.state.contractId, this.state.zip),
                    button: "Read More",
                    text: "How long do HVAC systems last?"
                  }
                ]});
                break;
            }
            break;
            case "2": 
              if (this.state.timeframe === "2") {
                this.setState({ "message": "<h1>THANK YOU FOR YOUR INTEREST.</h1></br>Upgrade quotes and equipment availability are valid for 30 days, so we encourage you to submit a quote request when you’re ready to move forward.<br/><br/>In the meantime, check out these helpful resources to learn more about the New HVAC Program, as well as general HVAC maintenance tips and tricks." });
                if (this.state.source === "2-10") {
                    this.setState( {"message": "<b>PLEASE NOTE:</b><br/><br/>Upgrade quotes and equipment availability are valid for 30 days, so we encourage you to submit a quote request when you’re ready to move forward.<br/><br/>In the meantime, learn more about the new HVAC Program."})
                     this.setState({ "links": [
                    {
                      link: format(this.state.linkObj.specialOffers, this.state.contractId, this.state.zip),
                      button: "Learn More",
                      text: "How does the New HVAC Program work?"
                    }
                  ]});
                } else {
                  this.setState({ "links": [
                    {
                      link: format(this.state.linkObj.specialOffers, this.state.contractId, this.state.zip),
                      button: "Learn More",
                      text: "How does the New HVAC Program work?"
                    },
                    {
                      link: format(this.state.linkObj.hvacInspection, this.state.contractId, this.state.zip),
                      button: "Read More",
                      text: "How do you conduct a DIY HVAC inspection?"
                    },
                    {
                      link: format(this.state.linkObj.howLong, this.state.contractId, this.state.zip),
                      button: "Read More",
                      text: "How long do HVAC systems last?"
                    }
                  ]});
                }
              } else {
                this.setState({ "message": "<h1>THANK YOU!</h1>The " + this.state.brand + " New HVAC Program is powered by Frontdoor Pro®. One of their trusted, independent service contractors will contact you within 2 business days to schedule your FREE in-home HVAC upgrade quote."});
              }
              break;
          default:
            this.setState({ "message": "<h1>THANK YOU!</h1>The " + this.state.brand + " New HVAC Program is powered by Frontdoor Pro®. One of their trusted, independent service contractors will contact you within 2 business days to schedule your FREE in-home HVAC upgrade quote."});
        }
      } else if(this.state.timeframe === "0") {
        if (this.state.working === "yes") {
          this.setState({ "message": "<h1>THANK YOU!</h1>The " + this.state.brand + " New HVAC Program is powered by Frontdoor Pro®. One of their trusted, independent service contractors will contact you within 2 business days to schedule your FREE in-home HVAC upgrade quote."});
        }
      } else {
        this.setState({ "message": "<h1>THANK YOU FOR YOUR INTEREST.</h1></br>Upgrade quotes and equipment availability are valid for 30 days, so we encourage you to submit a quote request when you’re ready to move forward.<br/><br/>In the meantime, check out these helpful resources to learn more about the New HVAC Program, as well as general HVAC maintenance tips and tricks." });
        if (this.state.source === "2-10") {
          this.setState({ "message": "<h1>THANK YOU FOR YOUR INTEREST.</h1></br>Upgrade quotes and equipment availability are valid for 30 days, so we encourage you to submit a quote request when you’re ready to move forward.<br/><br/>In the meantime, learn more about the new HVAC Program." });
                  this.setState({ "links": [
          {
            link: format(this.state.linkObj.specialOffers, this.state.contractId, this.state.zip),
            button: "Learn More",
            text: "How does the New HVAC Program work?"
          }
        ]});
        } else {
        this.setState({ "links": [
          {
            link: format(this.state.linkObj.specialOffers, this.state.contractId, this.state.zip),
            button: "Learn More",
            text: "How does the New HVAC Program work?"
          },
          {
            link: format(this.state.linkObj.hvacInspection, this.state.contractId, this.state.zip),
            button: "Read More",
            text: "How do you conduct a DIY HVAC inspection?"
          },
          {
            link: format(this.state.linkObj.howLong, this.state.contractId, this.state.zip),
            button: "Read More",
            text: "How long do HVAC systems last?"
          }
        ]});
        }
      }
      this.setState({ "showThankYou": true });
      this.setState({ "loading": false});
    }).catch(error => {
      console.log(error);
    })
  }

  setServiceRequest = (event) => {
    const value = event.target.value;
    this.setState({ [event.target.name]: value, "showServiceRequest": false }, () => {
      if ((this.state.timeframe === "0" && value === "2") || (this.state.timeframe === "1" && value === "2")) {
        this.setState( {"userFormMessage": "<b>SOUNDS LIKE AN HVAC UPGRADE COULD BE A GREAT OPTION.</b><br/><br/>Enter your information to get started:"})
        this.setState ( {"showForm": true} );
      } else {
        this.post();
      }
    });
  }

    setTimeframe = (event) =>  {
      this.setState({ [event.target.name]: event.target.value }, () => {
        if (this.state.timeframe && this.state.working) {
          this.setState({ "showMenu": false});
          if (this.state.timeframe === "0" && this.state.working === "yes") {
            this.setState({ "showForm": true });
          } else if (this.state.working === "no") {
            this.setState({ "showServiceRequest" : true});
          } else {
            this.post();
          }
        }
      });
    }
    setValue = (event) => {
      const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
      this.setState({ [event.target.name]: value });
    }

    render() {
      return (
        <div className="App">
          <LoadingOverlay
            active={this.state.loading}
            spinner
            text="Submitting..."
          >
            <header className={(this.state.addStyle ? "Footer-bottom-ahs" : null)}>
                <img src={this.state.logo} className="App-logo" alt="logo" />
            </header>
            <Container>
              <div className={(this.state.addTwoTenStyle ? "Background-twoten": null )}>
                <Headline show={this.state.showHeadline} headline={this.state.headline} subhead={this.state.subhead}></Headline>
                <div className="Max-width">
                  <Modal show={this.state.showModal} source={this.state.source}></Modal>
                  <Timeframe name="timeframe" value={this.state.timeframe} timeframes={timeframes} handleChange={this.setTimeframe} show={this.state.showMenu}></Timeframe>
                  <UserForm show={this.state.showForm} setValue={this.setValue} submit={this.post} agent={this.state.agent} message={this.state.userFormMessage} name={this.state.name} phone={this.state.phone} address={this.state.address} city={this.state.city} state={this.state.state} zip={this.state.zip} email={this.state.email}></UserForm>
                  <SweepstakesUserForm show={this.state.showSweepstakesForm} setValue={this.setValue} submit={this.post} agent={this.state.agent} name={this.state.name} phone={this.state.phone} address={this.state.address} city={this.state.city} state={this.state.state} zip={this.state.zip} email={this.state.email} rulesUrl={this.state.rulesUrl}></SweepstakesUserForm>
                  <ServiceRequest name="openServiceRequest" show={this.state.showServiceRequest} options={serviceRequestOptions} handleChange={this.setServiceRequest}></ServiceRequest>
                  <ThankYou show={this.state.showThankYou} message={this.state.message} buttonText={this.state.buttonText} links={this.state.links} cta={this.state.cta} bottomMessage={this.state.bottomMessage}></ThankYou>
                </div>
              </div>
            </Container>
            <Footer hidden={this.props.sweepstakes} policyLink={this.state.linkObj.policy} terms={this.state.linkObj.terms} addStyle={this.state.addStyle} addTwoTenStyle={this.state.addTwoTenStyle} brand={this.state.footerBrand} disclaimer={this.state.footerDisclaimer}></Footer>
          </LoadingOverlay>
        </div>
      );
  }
}

export default App;
